import React from 'react';
import styled, { css } from 'styled-components';
import { redColor, greenColor, lightGrey3Color } from 'js/config/style';

const statusStyle = {
  successful: css`
    font-weight: 500;
    background: ${greenColor};
    padding: 0 0.5rem;
    border-radius: 0.25rem;
    color: white;
    line-height: 2rem;
  `,
  failed: css`
    font-weight: 500;
    background: ${redColor};
    color: white;
    padding: 0 0.5rem;
    border-radius: 0.25rem;
    line-height: 2rem;
  `,
  void: css`
    font-weight: 500;
    color: white;
    background: ${lightGrey3Color};
    padding: 0 0.5rem;
    border-radius: 0.25rem;
    line-height: 2rem;
  `,
};

const smallStatusStyle = {
  successful: css`
    font-weight: 500;
    color: ${greenColor};
  `,
  failed: css`
    font-weight: 500;
    color: ${redColor};
  `,
  void: css`
    font-weight: 500;
    color: ${lightGrey3Color};
  `,
};

const Container = styled.div`
  display: inline-block;
  font-size: 0.8rem;
  margin-top: 10px;
  ${({ small, status }) => (small ? smallStatusStyle[status] : statusStyle[status])};
`;

export default ({ transaction, ...props }) => (
  <Container {...props} status={transaction.status} title={`Result code: ${transaction.result}`}>
    {transaction.status === 'failed' && !props.small ? 'Failed: ' : ''}
    {transaction.human_label}
  </Container>
);
